export default __webpack_public_path__ + "static/media/keyMessageMobile.53a5b110.svg";